import React from 'react';
import { Box, Flex, Link as ChakraLink, Button, useColorMode } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const { colorMode, toggleColorMode } = useColorMode();
  const userIsLoggedIn = user != null;

  const isPublicRoute = ['/login', '/register', '/', '/pricing'].includes(location.pathname);

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Box flex="1">
        <Flex
          as="nav"
          align="center"
          justify="space-between"
          wrap="wrap"
          padding="1.5rem"
          bg={colorMode === 'light' ? 'white' : 'gray.800'}
          color={colorMode === 'light' ? 'gray.600' : 'white'}
          borderBottom="1px"
          borderColor={colorMode === 'light' ? 'gray.200' : 'gray.700'}
        >
          <ChakraLink as={RouterLink} to={userIsLoggedIn ? "/app/dashboard" : "/"} fontSize="xl" fontWeight="bold">
            Pragma
          </ChakraLink>

          <Flex align="center" gap={4}>
            {isPublicRoute ? (
              <>
                <ChakraLink as={RouterLink} to="/pricing">
                  Pricing
                </ChakraLink>
                {!user && (
                  <>
                    <ChakraLink as={RouterLink} to="/login">
                      Login
                    </ChakraLink>
                    <Button
                      as={RouterLink}
                      to="/register"
                      colorScheme="blue"
                      size="sm"
                    >
                      Sign Up
                    </Button>
                  </>
                )}
              </>
            ) : (
              <>
                <ChakraLink as={RouterLink} to="/dashboard" hidden={userIsLoggedIn}>
                  Dashboard
                </ChakraLink>
                <Button
                  onClick={logout}
                  variant="ghost"
                  size="sm"
                >
                  Logout
                </Button>
              </>
            )}
            <Button onClick={toggleColorMode} size="sm">
              {colorMode === 'light' ? 'Dark' : 'Light'} Mode
            </Button>
          </Flex>
        </Flex>

        <Box as="main" p={4}>
          {children}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout; 